import { Box, Paper } from '@mui/material';
import { ReactNode } from 'react';

type DetailPanelProps = {
  children: ReactNode;
};

const EnhancedDetailPanel = ({ children }: DetailPanelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'sticky',
        left: { xs: 8, sm: 16, md: 24 },
        width: {
          xs: 'calc(100vw - 16px)', // Mobile
          sm: 'calc(100vw - 32px)', // Tablet
          md: 'calc(100vw - 320px - 48px)' // Desktop
        },
        boxSizing: 'border-box',
        my: 2
      }}>
      <Box
        sx={{
          width: 4,
          backgroundColor: (theme) => theme.palette.primary.main,
          opacity: 0.5,
          borderRadius: '4px 0 0 4px',
          alignSelf: 'stretch',
          flexShrink: 0
        }}
      />

      <Paper
        elevation={0}
        sx={{
          flex: 1,
          minWidth: 0,
          position: 'sticky',
          boxSizing: 'border-box',
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderLeft: 'none',
          borderRadius: '0 8px 8px 0',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)'
        }}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default EnhancedDetailPanel;
